import {
    ActionMatchType,
    ActionType,
    EntityNameMatchingActionDetails,
} from '@evidentid/tprm-portal-lib/models/entity-actions-review';
import { ActionDetails } from '@evidentid/tprm-portal-lib/models/entity-actions-review/commons/ActionDetails.model';

import { EntityActionScopeType } from '@/modules/entity-actions-review/types';

const actionScopeMap: Partial<Record<ActionType, EntityActionScopeType>> = {
    [ActionType.complianceWithCategoryResolution]: EntityActionScopeType.global,
    [ActionType.contractExtraction]: EntityActionScopeType.entity,
    [ActionType.endorsementFormNumberV1]: EntityActionScopeType.global,
    [ActionType.aieManuscriptCategorization]: EntityActionScopeType.entity,
    [ActionType.evaluatedEntityMappingV1]: EntityActionScopeType.entity,
    [ActionType.nonExtractionCriterionResolutionV1]: EntityActionScopeType.entity,
    [ActionType.documentDataReview]: EntityActionScopeType.entity,
};

export function getActionScopeType(entityAction: ActionDetails): EntityActionScopeType | null {
    if (entityAction.$action === ActionType.entityNameMatchingV1) {
        return (entityAction as EntityNameMatchingActionDetails).matchType === ActionMatchType.insured
            ? EntityActionScopeType.entity
            : EntityActionScopeType.global;
    }

    return actionScopeMap[entityAction.$action] || null;
}
